import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { forwardRef } from "react";
import hintCss from "hint.css/hint.min.css?inline-raw";
import { usePlainCss } from "../../hooks";
/**
 * This is a very basic `hint.css` implementation for a tooltip.
 *
 * @see https://kushagra.dev/lab/hint/
 */
// eslint-disable-next-line react/display-name

var BannerTooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "top" : _ref$position,
      color = _ref.color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      always = _ref.always,
      rounded = _ref.rounded,
      noAnimate = _ref.noAnimate,
      bounce = _ref.bounce,
      rest = _objectWithoutProperties(_ref, ["children", "className", "title", "position", "color", "size", "always", "rounded", "noAnimate", "bounce"]);

  usePlainCss(hintCss, "hint-css");
  return h("div", _extends({
    style: {
      position: "relative",
      display: "inline"
    },
    ref: ref,
    "aria-label": title,
    className: "hint--".concat(position, " hint--").concat(size, " ").concat(color ? "hint--".concat(color) : "", " ").concat(always ? "hint--always" : "", " ").concat(rounded ? "hint--rounded" : "", " ").concat(noAnimate ? "hint--no-animate" : "", " ").concat(bounce ? "hint--bounce" : "", " ").concat(className || "")
  }, rest), children);
});
export { BannerTooltip };